<template>
  <div>
    <header ref="headerRef" class="fixed inset-x-0 top-0 z-[1] border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur">
      <div class="inner flex flex-col gap-4 px-4 py-4 lg:flex-row lg:items-center lg:justify-between">
        <p class="header-title" @click="goPage('home')">평생교육 글로벌역량 플랫폼 관리자</p>
        <ul class="flex flex-wrap gap-2">
          <li :class="{ 'header-nav-active': currentPage === 'home' }" class="header-nav-item" @click="goPage('home')">
            수강신청 관리
          </li>
          <li
            :class="{
              'header-nav-active': currentPage === 'enrolmentStep1',
            }"
            class="header-nav-item"
            @click="goPage('enrolmentStep1')"
          >
            수강신청 등록
          </li>
          <li
            :class="{ 'header-nav-active': currentPage === 'busanSubmission' }"
            class="header-nav-item"
            @click="goPage('busanSubmission')"
          >
            자기주도학습 과제제출
          </li>
        </ul>
      </div>
    </header>
  </div>
</template>
<script>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const headerRef = ref(null);
    const currentPage = ref("");
    let resizeObserver = null;

    const goPage = (path) => {
      currentPage.value = path;
      router.push({ name: path });
    };

    const classAdd = () => {
      router.push({ name: "/enrolmentStep1" });
    };

    const updateHeaderHeight = () => {
      if (!headerRef.value) {
        return;
      }

      document.documentElement.style.setProperty("--app-header-height", `${headerRef.value.offsetHeight}px`);
    };

    onMounted(() => {
      updateHeaderHeight();

      if (typeof ResizeObserver !== "undefined" && headerRef.value) {
        resizeObserver = new ResizeObserver(() => {
          updateHeaderHeight();
        });
        resizeObserver.observe(headerRef.value);
      }

      window.addEventListener("resize", updateHeaderHeight);
    });

    onBeforeUnmount(() => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", updateHeaderHeight);
    });

    return {
      headerRef,
      goPage,
      classAdd,
      currentPage,
    };
  },
};
</script>
<style scoped>
.header-title {
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.header-nav-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0.55rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  color: #475569;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;
}

.header-nav-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
}

.header-nav-active {
  background: #eaf2ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}
</style>
